import { siteInfo } from '@/mocks/comics';
import SEOHead from '@/components/feature/SEOHead';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function AboutPage() {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '51漫画网',
    url: 'https://51manhua.com',
    description: siteInfo.description,
    contactPoint: {
      '@type': 'ContactPoint',
      email: siteInfo.contact.email,
      contactType: 'customer service',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '51漫画网的韩漫都是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，51漫画网上所有韩漫资源均为免费在线阅读，用户无需注册即可畅享海量韩漫大全。我们通过下拉式漫画全集呈现完整剧情，为读者提供优质的免费韩漫阅读服务。',
        },
      },
      {
        '@type': 'Question',
        name: '51漫画网的韩漫更新频率如何？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51漫画网每日更新300+部韩漫作品，覆盖恋爱、奇幻、动作、悬疑、搞笑、都市、古风等全类型。我们的编辑团队实时追踪韩国漫画最新连载，确保读者第一时间享受下拉式全集阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '在51漫画网阅读韩漫需要注册账号吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '不需要！51漫画网所有韩漫均支持免注册在线阅读。用户打开网站即可直接浏览韩漫大全，享受下拉式漫画阅读体验，无需任何注册流程。',
        },
      },
      {
        '@type': 'Question',
        name: '51漫画网支持什么设备阅读韩漫？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51漫画网采用响应式设计，完美支持电脑、平板和手机等各类设备。无论您使用什么设备，都能享受流畅的下拉式韩漫阅读体验，随时随地畅读精彩韩漫全集。',
        },
      },
      {
        '@type': 'Question',
        name: '如何在51漫画网找到想看的韩漫？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过51漫画网的分类导航浏览恋爱、奇幻、动作、悬疑等各类韩漫大全，也可以查看热门排行和强力推荐栏目发现优质韩漫。下拉式全集阅读方式让您可以一口气读完整个故事。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="关于我们 - 韩漫免费在线阅读平台 - 51漫画网"
        description="51漫画网是国内领先的韩漫免费在线阅读平台，提供海量韩漫大全资源。了解我们的品牌故事、用户口碑和联系方式，享受下拉式漫画全集阅读体验。"
        keywords="51漫画网,关于我们,韩漫平台,免费漫画网站,韩漫在线阅读"
        canonicalUrl="/about"
        schema={{ ...organizationSchema, ...faqSchema }}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900">
              关于 <span className="text-primary-600">51漫画网</span>
            </h1>
            <p className="text-lg text-foreground-600 mt-4 leading-relaxed max-w-2xl mx-auto">
              {siteInfo.slogan}
            </p>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-6">品牌介绍</h2>
            <div className="prose prose-sm max-w-none">
              <p className="text-foreground-700 leading-relaxed mb-4">
                51漫画网成立于2020年，是国内最早专注于韩国漫画免费在线阅读的平台之一。
                我们致力于为广大漫画爱好者打造一个内容丰富、体验流畅的<strong>韩漫大全</strong>阅读社区。
                平台上汇集了超过50,000部韩国漫画资源，涵盖恋爱、奇幻、动作、悬疑、搞笑、都市、古风等全品类，
                每日更新300+部热门<strong>韩漫</strong>作品，满足不同读者的阅读偏好。
              </p>
              <p className="text-foreground-700 leading-relaxed mb-4">
                51漫画网采用先进的<strong>下拉式漫画全集</strong>阅读技术，让读者无需翻页即可连续阅读完整剧情。
                这种沉浸式阅读方式极大提升了<strong>韩漫免费阅读</strong>体验，使读者能够一气呵成地享受精彩故事。
                我们始终坚持"免费、便捷、优质"的服务理念，所有漫画资源均无需注册即可在线阅读。
              </p>
              <p className="text-foreground-700 leading-relaxed">
                作为国内<strong>韩漫大全</strong>领域的领先平台，51漫画网拥有超过800万注册用户和1200万月活跃用户。
                我们的编辑团队每天精心筛选优质韩漫资源，确保读者能够在第一时间阅读到最新、最热门的<strong>韩国漫画</strong>连载。
                无论是经典完结作品还是最新连载<strong>韩漫</strong>，51漫画网都能为您提供完整流畅的阅读体验。
              </p>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">用户口碑</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <span key={s} className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className="ri-star-fill text-sm"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  "51漫画网的韩漫资源真的太全了！下拉式阅读体验超级流畅，一口气能看好多话，而且完全免费，是我每天必刷的漫画网站。"
                </p>
                <p className="text-xs text-foreground-500 font-medium">—— 漫画爱好者小王</p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <span key={s} className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className="ri-star-fill text-sm"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  "以前到处找韩漫资源很麻烦，自从发现了51漫画网，所有想看的韩漫大全都在这里了。更新速度也很快，强烈推荐！"
                </p>
                <p className="text-xs text-foreground-500 font-medium">—— 韩漫迷小李</p>
              </div>
              <div className="p-6 rounded-xl bg-background-50 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <span key={s} className="w-4 h-4 flex items-center justify-center text-primary-500">
                      <i className="ri-star-fill text-sm"></i>
                    </span>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed mb-3">
                  "下拉式全集阅读方式太赞了！手机上也能流畅阅读，不用注册就能看，51漫画网真的是良心韩漫免费阅读平台。"
                </p>
                <p className="text-xs text-foreground-500 font-medium">—— 漫画读者小张</p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-6">联系方式</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div>
                <div className="flex items-start gap-4 mb-6">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                    <i className="ri-mail-line text-lg"></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800">电子邮箱</h3>
                    <p className="text-sm text-foreground-600 mt-1">{siteInfo.contact.email}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 mb-6">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-wechat-line text-lg"></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800">微信公众号</h3>
                    <p className="text-sm text-foreground-600 mt-1">{siteInfo.contact.wechat}</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 flex-shrink-0">
                    <i className="ri-weibo-line text-lg"></i>
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800">官方微博</h3>
                    <p className="text-sm text-foreground-600 mt-1">{siteInfo.contact.weibo}</p>
                  </div>
                </div>
              </div>

              <div className="p-6 rounded-xl bg-background-100 border border-background-200/70">
                <h3 className="text-base font-semibold text-foreground-800 mb-4">给我们留言</h3>
                <form
                  id="about-contact-form"
                  data-readdy-form
                  className="space-y-4"
                  action="https://readdy.ai/api/form/d9osn1iftmtnfcfh0dbg"
                  method="POST"
                >
                  <div>
                    <label htmlFor="contact_name" className="block text-sm text-foreground-700 mb-1">姓名</label>
                    <input
                      type="text"
                      id="contact_name"
                      name="name"
                      className="w-full px-3 py-2 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的姓名"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact_email" className="block text-sm text-foreground-700 mb-1">邮箱</label>
                    <input
                      type="email"
                      id="contact_email"
                      name="email"
                      className="w-full px-3 py-2 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors"
                      placeholder="请输入您的邮箱"
                    />
                  </div>
                  <div>
                    <label htmlFor="contact_message" className="block text-sm text-foreground-700 mb-1">留言内容</label>
                    <textarea
                      id="contact_message"
                      name="message"
                      rows={4}
                      maxLength={500}
                      className="w-full px-3 py-2 text-sm rounded-lg border border-background-300 bg-background-50 text-foreground-900 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                      placeholder="请输入您的留言（500字以内）"
                    ></textarea>
                  </div>
                  <div className="contact-honeypot">
                    <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
                  </div>
                  <button
                    type="submit"
                    className="w-full px-4 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    发送留言
                  </button>
                </form>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl font-heading font-bold text-foreground-900 mb-8 text-center">常见问题</h2>
            <div className="space-y-3">
              {faqSchema.mainEntity.map((faq, i) => (
                <details key={i} className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                    <span className="text-sm font-medium text-foreground-800">{faq.name}</span>
                    <span className="w-5 h-5 flex items-center justify-center text-foreground-400 group-open:rotate-180 transition-transform">
                      <i className="ri-arrow-down-s-line"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.acceptedAnswer.text}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}